import Vue from 'vue';

import App from './App.vue';
import router from './router';

import { default as globalMixin } from '@/mixins/global.mixin.js';
Vue.mixin(globalMixin);

import './http';

import { default as store } from '@/store';

import './assets/swiper/swiper-bundle.min.css';
require('./assets/swiper/swiper-bundle.min.js');

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

window.parseObject = function(obj) {
    return JSON.parse(JSON.stringify(obj));
};
